/**
 * This is the controller for Item > Suppliers > Actions > Allow More Submissions (pop)
 * @ listingModel is the modal ng-model passed while generating the link from actions menu
 * @ $uibModalInstance is the modal instance from ui.bootstrap.modal
 */
(function() {
    'use strict';

    var DistCtrl = function ($scope, ajaxCall, $uibModalInstance, listingModel) {

        console.log('DistCtrl init!');
        $scope.distModel = {};

        //To close the pop
        $scope.cancel = function(e) {
            if(angular.isDefined(e)){
                e.preventDefault();
            }
            $uibModalInstance.dismiss('cancel');
        };

        // function called on clicking Confirm button
        // peforms ajax call
        // refresh's the ng-model (listingModel) based on the data returned from ajax call
        $scope.confirmSubmission = function(e){
            if(angular.isDefined(e)){
                e.preventDefault();
            }
            var additionalSubmissions  =  $scope.distModel.additionalSubmissions;
            var distributionId         =  $scope.distModel.distributionId;

            var data     =  'additionalSubmissions=' + additionalSubmissions + '&id=' + distributionId;
            var ajaxUrl  =  WEBAPP_PATH + "/distribution/addSubmissions?";

            ajaxCall.getData(ajaxUrl + data).then(
                function(result) {
                    // refreshing the ng-model (listingModel) based on the data returned from ajax call
                    listingModel.refresh++;
                    // the results will be passed back to ng-model (listingModel)
                    $uibModalInstance.close(listingModel);
                },
                function(result) {
                     // handling on error : close the pop
                     $uibModalInstance.dismiss('cancel');
                }
            );
        }
    }

    DistCtrl.$inject = ['$scope', 'ajaxCall', '$uibModalInstance', 'params'];
    angular.module('app').controller('DistCtrl', DistCtrl);

}());